import { ChevronRight } from "lucide-react";
import React, { useState } from "react";

const Footer = ({sectionRef,is2kView}) => {
  const [formData, setFormData] = useState({ email: "" });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setSuccessMessage("");

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(
        "https://jsonplaceholder.typicode.com/posts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit form. Please try again.");
      }

      setSuccessMessage("Form submitted successfully!");
      setFormData({ email: "" });
    } catch (error) {
      setErrors({ form: error.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  const {journeyRef,awardsRef,expertiseRef}=sectionRef;
  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" }); 
    }
  };

  return (
    <footer className={`font-RedHat mb-10 text-white px-10 md:px-30 lg:px-20 xl:px-44 ${is2kView && "2xl:px-80"}`}>
      <div className=" bg-[#101010] mt-10 rounded-3xl py-10 px-5">
      <div className="flex w-full flex-col gap-5">
          <h3 className="text-2xl lg:text-3xl xl:text-4xl font-bold capitalize leading-snug text-left font-Ubuntu ">
           Dr. C Imthyaz Sheriff
          </h3>
          <p className="text-base font-thin capitalize">
            Driven by vision, innovation, and results, Imthyaz Sheriff is a
            dynamic leader with a proven track record of transforming ideas into
            impactful outcomes.
          </p>
          <hr className="w-full" />
          <ul className="flex lg:flex-row md:flex-row flex-col lg:gap-20 gap-10 uppercase text-base">
            {/* <li className="lg:hover:text-primary transition-all duration-300 ease-in-out">
              <a onClick={()=>scrollToSection(journeyRef)}>Journey</a>
            </li> */}
            <li className="cursor-pointer lg:hover:text-primary transition-all duration-300 ease-in-out">
              <a onClick={()=>scrollToSection(awardsRef)}>Awards</a>
            </li>
            <li className="cursor-pointer lg:hover:text-primary transition-all duration-300 ease-in-out">
              <a onClick={()=>scrollToSection(expertiseRef)}>Expertise</a>
            </li>
          </ul>
        {/* <div className="lg:w-[40%] w-full ">
          <div className="bg-black p-5 rounded-xl flex flex-col gap-2">
            <h6 className="text-base font-thin">Subscribe</h6>
            <p className="text-sm text-[#8E9BAA] font-thin">
              Stay current with all things in the technolgies
            </p>
            <form onSubmit={handleSubmit} className="max-w-full py-5">
              <div className="flex items-start gap-2 bg-black  rounded-md">
                <div className="flex-grow">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                    className="w-full p-3 bg-transparent border border-[#C7CCD1] rounded-xl text-white placeholder-gray-400 focus:outline-none focus:border-white"
                  />
                  {errors.email && (
                    <p className="text-red-600 text-[10px] mt-1">
                      {errors.email}
                    </p>
                  )}
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`flex items-center justify-center px-2 lg:px-6 py-3 ${
                    isSubmitting
                      ? "bg-gray-600"
                      : "bg-transparent hover:bg-white hover:text-black"
                  } text-white  rounded-md transition duration-200`}
                >
                  {isSubmitting ? "Submitting..." : "Subscribe"}
                  {!isSubmitting && (
                    <span className="ml-2">
                      <ChevronRight size={18} />
                    </span>
                  )}
                </button>
              </div>
              {errors.form && (
                <p className="text-red-400 text-center text-sm mt-3">
                  {errors.form}
                </p>
              )}
              {successMessage && (
                <p className="text-green-400 text-center text-sm mt-3">
                  {successMessage}
                </p>
              )}
            </form>
          </div>
        </div> */}
      </div>
      <hr className="w-full my-10" />

      <div className="text-[12px] text-[#8E9BAA] font-normal flex flex-row justify-between flex-wrap-reverse gap-10">
        <p className="lg:text-left lg:w-fit text-center w-full">
          © Imthyaz Sheriff. All rights Reserved.
        </p>

        <ul className="flex flex-row gap-5 uppercase text-white">
          <li className="hover:text-[#0077b5] transition-all duration-300 ease-in-out">
            <a href="https://www.linkedin.com/in/imthyaz-sheriff/">LinkedIn</a>
          </li>
          <li className="hover:text-[#316ff6] transition-all duration-300 ease-in-out">
            <a href="https://www.facebook.com/share/15twHF542B/">Facebook</a>
          </li>
          {/* <li>
            <a href="">Twitter X</a>
          </li> */}
          <li className="hover:text-[#E1306C] transition-all duration-300 ease-in-out">
            <a href="https://www.instagram.com/imthyaz.s/?hl=en">Instagram</a>
          </li>
        </ul>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
